import Api from "../apiService";

class authApi {
  // До принятия текущей версии возвращает agreement_required без токена сессии.
  create(data) {
    return Api.postRequest(`auth/login`, data, {});
  }

  // Завершает вход одноразовым подтверждением пароля, без повторной отправки реквизитов.
  confirmAgreement(data) {
    return Api.postRequest(`auth/confirm_agreement`, data, {}, {
      skipErrorNotification: true,
    });
  }

  loginWithToken(token) {
    return Api.postRequest(`auth/login_with_token`, { token }, {});
  }
}

export default new authApi();
